import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback, useMemo } from "react";
import type { StepConfig } from "../types/step";
export function useStepNavigation(steps) {
  const $ = _c(37);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.get("process") || "profile";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const paramStepKey = t0;
  let t1;
  if ($[2] !== paramStepKey) {
    t1 = s => s.key === paramStepKey;
    $[2] = paramStepKey;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const currentStepIndex = steps.findIndex(t1);
  const currentStep = currentStepIndex >= 0 ? currentStepIndex + 1 : 1;
  const stepConfig = steps[currentStep - 1];
  const t2 = currentStep < steps.length;
  const t3 = currentStep > 1;
  let t4;
  if ($[4] !== currentStep || $[5] !== steps.length || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      currentStep,
      totalSteps: steps.length,
      canGoNext: t2,
      canGoBack: t3,
      isLoading: false
    };
    $[4] = currentStep;
    $[5] = steps.length;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const navigationState = t4;
  let t5;
  if ($[9] !== searchParams) {
    t5 = searchParams?.get("rawUnitId");
    $[9] = searchParams;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const rawUnitId = t5;
  let t6;
  if ($[11] !== searchParams) {
    t6 = searchParams?.get("sellerUnitId");
    $[11] = searchParams;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const sellerUnitId = t6;
  let t7;
  if ($[13] !== searchParams) {
    t7 = searchParams?.get("groupId");
    $[13] = searchParams;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const groupId = t7;
  let t8;
  if ($[15] !== groupId || $[16] !== pathname || $[17] !== rawUnitId || $[18] !== router || $[19] !== sellerUnitId || $[20] !== steps) {
    t8 = stepNumber => {
      const stepKey = steps[stepNumber - 1]?.key;
      if (!stepKey) {
        return;
      }
      let url;
      if (sellerUnitId) {
        url = `${pathname}?sellerUnitId=${sellerUnitId}&`;
      } else {
        if (rawUnitId) {
          url = `${pathname}?rawUnitId=${rawUnitId}&`;
        } else {
          url = `${pathname}?`;
        }
      }
      if (groupId) {
        url = url + `groupId=${groupId}&process=${stepKey}`;
      } else {
        url = url + `process=${stepKey}`;
      }
      router.push(url);
    };
    $[15] = groupId;
    $[16] = pathname;
    $[17] = rawUnitId;
    $[18] = router;
    $[19] = sellerUnitId;
    $[20] = steps;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const navigateToStep = t8;
  let t9;
  if ($[22] !== currentStep || $[23] !== navigateToStep || $[24] !== navigationState.canGoNext) {
    t9 = () => {
      if (navigationState.canGoNext) {
        navigateToStep(currentStep + 1);
      }
    };
    $[22] = currentStep;
    $[23] = navigateToStep;
    $[24] = navigationState.canGoNext;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const navigateNext = t9;
  let t10;
  if ($[26] !== currentStep || $[27] !== navigateToStep || $[28] !== navigationState.canGoBack) {
    t10 = () => {
      if (navigationState.canGoBack) {
        navigateToStep(currentStep - 1);
      }
    };
    $[26] = currentStep;
    $[27] = navigateToStep;
    $[28] = navigationState.canGoBack;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const navigateBack = t10;
  let t11;
  if ($[30] !== currentStep || $[31] !== navigateBack || $[32] !== navigateNext || $[33] !== navigateToStep || $[34] !== navigationState || $[35] !== stepConfig) {
    t11 = {
      currentStep,
      stepConfig,
      navigationState,
      navigateToStep,
      navigateNext,
      navigateBack
    };
    $[30] = currentStep;
    $[31] = navigateBack;
    $[32] = navigateNext;
    $[33] = navigateToStep;
    $[34] = navigationState;
    $[35] = stepConfig;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  return t11;
}